module.exports = __webpack_public_path__ + "img/hand-dots.93af9397.svg";